import React, { useMemo, useEffect, useState } from 'react';
import { Row, Col } from 'tea-component';
import SvgIcon from '../../../SvgIcon';
import { getImg } from '@/pages/home/_config/getImgs';
import { mathFormat } from '@/pages/home/utils/search';
import { useIntl } from 'umi';
import { isEmpty } from '@/pages/intelligence/utils/commonUtils';
import ProgressContext from '@/pages/opinion/components/ProgressContext';
import steam from '@/pages/opinion/assets/svg/channel/steam.svg';
import metacritic from '@/pages/opinion/assets/svg/channel/metacritic.svg';
import { steamRateMap } from '@/pages/opinion/constants/channel';
import moment from 'moment';
import { gotoOpinionGame } from '@/pages/home/utils/utils';
import { getPercentageInfo } from '@/pages/opinion/utils';
import NoData from '@/pages/intelligence/components/NoData';
import { IS_GLOBAL } from '@/pages/home/_config/config';
import { OPINIONFEEDSGAMES } from '@/pages/home/components/NavHeader/_config';

export default function Opinion(props: any) {
  const { dataOpinion = {}, currentItem = {}, competitorList = [] } = props;
  const { mentions_and_sentiment: mentionsAndSentiment = {}, keywords = {} } = dataOpinion || {};
  const { positive = [], negative = [] } = keywords
  const { metacritic_stats: metacriticStats = {}, steam_stats: steamStats = {} } = mentionsAndSentiment || {};
  const { meta_score: metaScore = {}, user_score: userScore = {}, date: mentionsAndSentimentDate = '' } = metacriticStats || {};
  const { review: metaScoreReview = 0, score: metaScoreSco = 0 } = metaScore || {};
  const { review: userScoreReview = 0, score: userScoreSco = 0 } = userScore || {};
  const { all_reviews: allReviews = {}, date: steamStatSdate = '' } = steamStats || {};
  const { review: allReviewSreview = 0, score: allReviewSscore = 0, name: allReviewSname = '' } = allReviews || {};

  const [isFirstLeftNoData, setIsFirstLeftNoData] = useState(true);
  const [isFirstRightData, setIsFirstRightNoData] = useState(true);
  const [isSecondLeftData, setIsSecondLeftNoData] = useState(true);
  const [isSecondRightData, setIsSecondRightNoData] = useState(true);
  const KEYWORDS_IS_EMPTY = !positive?.length && !negative?.length
  const { formatMessage, locale } = useIntl(); // 中英切换方法
  const dealOpinionNumber = (str: any) => {
    if (!str || isNaN(str) || Number(str) === 0) return '-';
    return Number(str).toFixed(1);
  };

  const disabledOpinions = useMemo(() => {
    return currentItem?.opinion && currentItem?.opinion == 2 ? true : false;
  }, [currentItem]);

  const gotoOpinions = (item: any, tab = 'socialMedia', path = '/opinion/Feeds/Feeds') => {
    const idType = 'unified_id';
    const { game_id, entity_type, opinionGameId = '' } = item || {};
    const gameId = opinionGameId !== '' ? opinionGameId : game_id;
    const gameType = entity_type;
    if (disabledOpinions) {
      gotoOpinionGame(gameId, gameType, idType, tab, path);
    }
  }

  useEffect(() => {
    setIsFirstLeftNoData(metaScoreReview === 0 && metaScoreSco === 0);
    setIsFirstRightNoData(userScoreReview === 0 && userScoreSco === 0);
    setIsSecondLeftNoData(allReviewSname === '');
    setIsSecondRightNoData(allReviewSreview === 0 && allReviewSscore === 0);
  }, [steamStats, metacriticStats]);

  // 临时方案，针对Gloabl环境下，有以下三款游戏的舆情权限的用户，跳转到舆情Feeds页面
  const opinionPathCur = useMemo(() => {
    const { game_id, entity_type, opinionGameId = '' } = currentItem || {};
    const gameId = opinionGameId !== '' ? opinionGameId : game_id;
    if (IS_GLOBAL && OPINIONFEEDSGAMES?.includes(gameId)) {
      return '/opinion/Feeds/Feeds';
    } else {
      return '/opinion/Overview/KeyMetrics';
    }
  }, [IS_GLOBAL, OPINIONFEEDSGAMES, currentItem]);

  return (
    <>
      <div className="intelligence opinion-intelligence">
        <Row gap={24} showSplitLine>
          <>
            <Col span={currentItem?.entity_type === 'mobile' ? 7 : 12}>
              <div className={disabledOpinions ? 'intelligence-opinionsdiv' : 'intelligence-opinionsdiv-normal'} onClick={() => {
                gotoOpinions(currentItem, '', opinionPathCur);
              }}>
                <div className={disabledOpinions ? 'intelligence-title' : 'intelligence-normal'}>{formatMessage({ id: 'dbh_mentions' })}</div>
                <div className='intelligence-num'>
                  {!dataOpinion?.mentions_and_sentiment?.mentions ? 0 : mathFormat(dataOpinion?.mentions_and_sentiment?.mentions)}
                </div>
              </div>
            </Col>
            <Col span={currentItem?.entity_type === 'mobile' ? 7 : 12}>
              <div className={disabledOpinions ? 'intelligence-opinionsdiv' : 'intelligence-opinionsdiv-normal'} onClick={() => {
                gotoOpinions(currentItem, '', opinionPathCur)
              }}>
                <div className={disabledOpinions ? 'intelligence-title' : 'intelligence-normal'}>{formatMessage({ id: 'dbh_sentiment' })}</div>
                <div className='intelligence-num'>{dealOpinionNumber(dataOpinion?.mentions_and_sentiment?.sentiment)}</div>
              </div>
            </Col>
            {currentItem?.entity_type === 'mobile' && <>
              <Col span={10}>
                <div className={disabledOpinions ? 'intelligence-opinionsdiv' : 'intelligence-opinionsdiv-normal'} onClick={() => {
                  gotoOpinions(currentItem, 'gameStore')
                }}>
                  <div className={disabledOpinions ? 'intelligence-title' : 'intelligence-normal'}>{formatMessage({ id: 'dbh_score' })}</div>
                  <div className='intelligence-flex'>
                    <span className='intelligence-num intelligence-num-storerank'>
                      <img src={getImg('Appstore')} className='intelligence-img' />
                      {dealOpinionNumber(dataOpinion?.mentions_and_sentiment?.app_store_score)}
                    </span>
                    <span className='intelligence-num intelligence-num-storerank'>
                      <img src={getImg('vodel')} className='intelligence-img' />
                      {dealOpinionNumber(dataOpinion?.mentions_and_sentiment?.google_play_score)}
                    </span>
                  </div>
                </div>
              </Col>
            </>}
          </>
        </Row>
      </div>
      <div className="Keywords-box">
        <div
          className={disabledOpinions ? 'Keywords-box-title' : 'Keywords-box-normal'}
          onClick={() => {
            gotoOpinions(currentItem, 'newsMedia');
          }}
        >
          {formatMessage({ id: 'dbh_keywords' })}
          <SvgIcon type="arrow-right" className="Keywords-box-icon" />
        </div>
        {KEYWORDS_IS_EMPTY ? <div className='Keywords-box-nodata-box'>
          <NoData text={formatMessage({ id: 'dbi_search_empty' })} />
        </div> : <>
          <div className="Keywords-box-flex">
            <div className="Keywords-box-lab">
              {formatMessage({ id: 'dbh_search_pos' })}
            </div>
            <div className="Keywords-box-message">
              {
                dataOpinion?.keywords?.positive?.length > 0 ? <>
                  {dataOpinion?.keywords?.positive?.map((item: any, index: any) => {
                    return (
                      <span
                        key={index}
                        className="Keywords-box-greentext"
                        onClick={() => {
                          gotoOpinions(
                            currentItem,
                            'socialMedia',
                          );
                        }}
                      >
                        {item.keyword} {mathFormat(item.mentions)}
                      </span>
                    );
                  })}
                </> : '-'
              }
            </div>
          </div>
          <div className="Keywords-box-flex">
            <div className="Keywords-box-lab">
              {formatMessage({ id: 'dbh_search_neg' })}
            </div>
            <div className="Keywords-box-message">
              {
                dataOpinion?.keywords?.negative?.length > 0 ? <>
                  {dataOpinion?.keywords?.negative?.map((item: any, index: any) => {
                    return (
                      <span
                        key={index}
                        className={'Keywords-box-redtext'}
                        onClick={() => {
                          gotoOpinions(
                            currentItem,
                            'socialMedia',
                          );
                        }}
                      >
                        {item.keyword} {mathFormat(item.mentions)}
                      </span>
                    );
                  })}
                </> : '-'
              }
            </div>
          </div>
        </>}
      </div>

      {
        currentItem?.entity_type === 'combine' ?
          <>
            {
              isEmpty(steamStats) ?
                <div className={`lifetime-reviews${(!isFirstLeftNoData && !isFirstRightData) ? '' : ' lifetime-reviews-single-nodata'}`}>
                  <div className="lifetime-reviews-header">
                    <span className="lifetime-reviews-img"><img src={metacritic} /></span>
                    <span className="lifetime-reviews-title">{formatMessage({ id: 'Lifetime Reviews' })}</span>
                    {(!isFirstLeftNoData || !isFirstRightData) &&
                      <span className="lifetime-reviews-date">{mentionsAndSentimentDate !== '' ? moment(mentionsAndSentimentDate).format('YYYY-MM-DD') : ''}</span>
                    }
                  </div>
                  <div className="lifetime-reviews-body">
                    {(isFirstLeftNoData && isFirstRightData) ?
                      <NoData text={formatMessage({ id: 'dbi_search_empty' })} /> :
                      <div className="lifetime-reviews-flex">
                        {!isFirstLeftNoData && <ProgressContext
                          key={'meta_score'}
                          percent={metaScoreSco}
                          circle
                          sentiment
                          strokeWidth={10}
                          sizeWidth={120}
                          title={formatMessage({ id: 'Metascore' })}
                          text={metaScoreSco}
                          reviewNum={metaScoreReview}
                        />}
                        {!isFirstRightData && <ProgressContext
                          key={'user_score'}
                          percent={userScoreSco * 10}
                          circle
                          sentiment
                          strokeWidth={10}
                          sizeWidth={120}
                          title={formatMessage({ id: 'User Score' })}
                          text={userScoreSco}
                          reviewNum={userScoreReview}
                        />}
                      </div>
                    }
                  </div>
                </div>
                :
                <div className={`lifetime-reviews${(!isSecondLeftData && !isSecondRightData) ? '' : ' lifetime-reviews-single-nodata'}`}>
                  <div className="lifetime-reviews-header">
                    <span className="lifetime-reviews-img"><img src={steam} /></span>
                    <span className="lifetime-reviews-title">{formatMessage({ id: 'Lifetime Reviews' })}</span>
                    {(!isSecondLeftData || !isSecondRightData) &&
                      <span className="lifetime-reviews-date">{steamStatSdate !== '' ? moment(steamStatSdate).format('YYYY-MM-DD') : ''}</span>}
                  </div>
                  <div className="lifetime-reviews-body">
                    {(isSecondLeftData && isSecondRightData) ?
                      <NoData text={formatMessage({ id: 'dbi_search_empty' })} /> :
                      <div className="lifetime-reviews-flex">
                        {!isSecondLeftData && <ProgressContext
                          title={allReviewSname !== '' ? formatMessage({ id: allReviewSname }) : ''}
                          iconType={steamRateMap[allReviewSname]?.icon}
                        />}
                        {!isSecondRightData && <ProgressContext
                          key='user_score'
                          percent={allReviewSscore * 100}
                          circle
                          sentiment
                          strokeWidth={10}
                          sizeWidth={120}
                          text={getPercentageInfo(allReviewSscore * 100 || 0, 100, 0, '0%')}
                          title={formatMessage({ id: 'Positive' })}
                          reviewNum={allReviewSreview}
                        />}
                      </div>
                    }
                  </div>
                </div>
            }
          </>
          :
          <div className="intelligence">
            <>
              <div
                className={disabledOpinions ? 'Keywords-box-title' : 'Keywords-box-normal'}
                onClick={() => {
                  gotoOpinions(
                    currentItem,
                    'newsMedia',
                  );
                }}
              >
                {formatMessage({ id: 'dbh_news' })}
                <SvgIcon type="arrow-right" className="Keywords-box-icon" />
              </div>
              {(Array.isArray(dataOpinion?.news) && dataOpinion?.news?.length > 0) ? dataOpinion?.news?.map((item: any, index: any) => {
                return (
                  <div key={index} className="Keywords-box-desc">
                    <div className="Keywords-box-subtitle">{(locale === 'zh-CN' ? item.title_cn : item.title_en) || item.title}</div>
                    <div className="Keywords-box-cont">
                      <div className="Keywords-box-wrapper">
                        <div className="Keywords-box-text">
                          <span
                            className="Keywords-box-more"
                            onClick={() => {
                              gotoOpinions(
                                currentItem,
                                'newsMedia',
                              );
                            }}
                          >
                            {formatMessage({ id: 'dbh_more' })}
                          </span>
                          <span>{(locale === 'zh-CN' ? item.content_cn : item.content_en) || item.content}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }) : <div className='Keywords-box-nodata-box'>
                <NoData text={formatMessage({ id: 'dbi_search_empty' })} />
              </div>}
            </>
          </div>
      }
    </>
  );
}
